
import React, { useEffect } from 'react';
import { HelmetProvider } from 'react-helmet-async';

import { WhatsAppProvider } from './contexts/WhatsAppContext';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import HomePage from '../src/Pages/Front/HomePage/HomePage';

import About from './Pages/Front/About/About';

import Contact from './Pages/Front/Contact/Contact';
import Carousel from './Pages/Front/Carousel/Carousel';

import "./App.css";
import StudentLayout from './Component/Layouts/App/Candidates/StudentApp/StudentLayout';
import Login from './Pages/App/Candidate/Login/Login';
import Home from './Pages/App/Candidate/Home/Home';
import Course from './Pages/App/Candidate/Course/Course';
import Job from './Pages/App/Candidate/Job/Job';
import Club from './Pages/App/Candidate/Club/Club';
import StudentProfile from './Pages/App/Candidate/StudentProfile/StudentProfile';
import Achievements from './Pages/App/Candidate/Achievements/Achievements';
import AchievementDetail from './Pages/App/Candidate/Achievements/AchievementDetail';
import ActivityFeed from './Pages/App/Candidate/ActivityFeed/ActivityFeed';
import WebLayout from './Component/Layouts/Web/Student/WebLayout';
import WebLogin from './Pages/Web/Student/Login/Login';
import WebHome from './Pages/Web/Student/Home/Home';
import WebCourse from './Pages/Web/Student/Course/Course';
import WebJob from './Pages/Web/Student/Job/Job';
import WebClub from './Pages/Web/Student/Club/Club';
import WebProfile from './Pages/Web/Student/Profile/Profile';
import WebAchievements from './Pages/Web/Student/Achievements/Achievements';
import WebAchievementDetail from './Pages/Web/Student/Achievements/AchievementDetail';
import WebActivity from './Pages/Web/Student/Activity/Activity';

import Event from './Pages/Front/Event/Event';
import HackathonHome from './Pages/Front/Hackathon/HomePage';
import Hackathon from './Pages/Front/Hackathon/Hackathon';
import SubmitPpt from './Pages/Front/Hackathon/SubmitPpt';
const Layout = () => {
  useEffect(() => {
    const getCookie = (name) => {
      const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
      return match ? match[2] : null;
    };
  
    const getFbclid = () => {
      const params = new URLSearchParams(window.location.search);
      return params.get('fbclid');
    };
  
    const fbp = getCookie('_fbp');
    const fbcCookie = getCookie('_fbc');
    const fbclid = getFbclid();
  
    const fbcGenerated = fbclid ? `fb.1.${Date.now()}.${fbclid}` : null;
  
    if (fbp && !sessionStorage.getItem('_fbp')) {
      sessionStorage.setItem('_fbp', fbp);
    }
  
    if ((fbcCookie || fbcGenerated) && !sessionStorage.getItem('_fbc')) {
      sessionStorage.setItem('_fbc', fbcCookie || fbcGenerated);
    }
  }, []);

  

  return (
    <>
      {/* <FrontHeader /> */}
      <Routes>

        <Route exact path="/" element={<HomePage />} />
        <Route exact path="/carousel" element={<Carousel />} />
        <Route exact path="/about" element={<About />} />
        {/* <Route exact path="/about_us" element={<About />} /> */}
        <Route exact path="/contact" element={<Contact />} />
        <Route path="/events" element={<Event />} />
        <Route path="/hackathonreg" element={<HackathonHome />} />
        <Route path="/hackathon/register" element={<Hackathon />} />
        <Route path="/hackathon/submit-ppt" element={<SubmitPpt />} />

        <Route path="/student/login" element={<WebLogin />} />
        <Route path="/student" element={<WebLayout />}>
          <Route index element={<WebHome />} />
          <Route path="course" element={<WebCourse />} />
          <Route path="job" element={<WebJob />} />
          <Route path="club" element={<WebClub />} />
          <Route path="profile" element={<WebProfile />} />
          <Route path="achievements" element={<WebAchievements />} />
          <Route path="achievement" element={<WebAchievementDetail />} />
          <Route path="activity" element={<WebActivity />} />
        </Route>

        <Route path="/candidate/login" element={<Login />} />
        <Route path="/candidate" element={<StudentLayout />}>
          <Route index element={<Home />} />
          <Route path="course" element={<Course />} />
          <Route path="job" element={<Job />} />
          <Route path="club" element={<Club />} />
          <Route path="profile" element={<StudentProfile />} />
          <Route path="achievements" element={<Achievements />} />
          <Route path="achievement" element={<AchievementDetail />} />
          <Route path="activity" element={<ActivityFeed />} />
        </Route>
      </Routes>
    </>
  );
};
const App = () => {
  return (
    <HelmetProvider>
      <WhatsAppProvider>
        <Router>
          <Layout />
        </Router>
      </WhatsAppProvider>
    </HelmetProvider>
  );
};

export default App;
